import React, { useEffect, useState } from 'react';
import { SelectField } from './SelectField';
import { ComboboxOption } from 'types/bronson-react';
import { useTranslation } from 'react-i18next';
import { Contract, ContractDetails } from 'cpfr-common';
import { LicensePlate } from '../../license-plate/LicensePlate';

export const ContractFilterSelection: React.FC<{ clearing: boolean; contracts: (Contract & ContractDetails)[] }> = ({
    clearing,
    contracts,
}) => {
    const { t } = useTranslation('request-history');

    const [contractOptions, setContractOptions] = useState<ComboboxOption[]>([]);

    useEffect(() => {
        if (contracts?.length) {
            const filteredContracts = contracts?.filter(
                (contract) => contract.contractNumber && contract.licensePlate && contract.carModel,
            );
            const modifiedContracts: ComboboxOption[] = filteredContracts?.map((contract) => {
                const { carModel, productTypeFR, licensePlate, contractNumber, isActive } = contract;
                const getProductTypeValue = (): string =>
                    (isActive ? productTypeFR : `(${t(`filters.contract-expired`)})`) || '';
                return {
                    key: contractNumber,
                    value: {
                        textValue: contractNumber,
                        content: (
                            <div>
                                <LicensePlate registrationNumber={licensePlate} />
                                <br aria-hidden="true" />
                                <b>{contractNumber + ` ${getProductTypeValue()}`}</b>
                                <br aria-hidden="true" />
                                <b>{carModel}</b>
                                <br aria-hidden="true" />
                            </div>
                        ),
                    },
                };
            });
            setContractOptions(modifiedContracts || []);
        }
    }, [contracts]);

    const finalOptions: ComboboxOption[] = [
        { key: 'all', value: t('filters.contract-filter-default') },
        ...(contractOptions || []),
    ];

    return (
        <SelectField
            testId={'contract-filter'}
            name={'contractFilter'}
            options={finalOptions}
            label={t('filters.contract-filter-header')}
            visible={!clearing}
        />
    );
};
